import React, { Fragment } from "react";
import externalLink from "../../../assets/images/external-link.png";
import Field from "../../Common/Field/Field";


const ProcessUpdatesList = props => {
  let stylePage = listValue => {
    // props.history.push("/StylePage", 
    {
      let action =
        (props.styleRights.web.edit && "edit") ||
        (props.rights.web.view && "view");
      let newSearch = "?" + new URLSearchParams({
        action: action,
        _id: listValue._id,
        hash: `seleted${listValue.code.split("-").join("")}`
      }).toString()
      window.open(`/StylePage${newSearch}#seleted${listValue.code.split("-").join("")}`, "_blank")
      // window.open(`/StylePage${newSearch}`, "_blank")
    };

  };
  let samplePage = data => {
    let action = (props.sampleRights.sampleRequest.web.edit && "edit") || (props.sampleRights.sampleRequest.web.view && "view");
    let search = "?" + new URLSearchParams({
      action: action,
      _id: data._id
    }).toString()
    window.open(`/Sample${search}`, "_blank")
  }
  let select = {}
  if (props.type === "bulkUpdateProcess") {
    select = { Select: "" }
  }
  return (
    <Fragment>
      <h6>Process Name: {props.processType && props.processType.toUpperCase()}</h6>
      <tbody>
        <tr>
          {props.type !== "bulkUpdateProcess" && <td className="report-header text-center border">
            S.No
          </td>}
          {props.list !== undefined &&
            Array.isArray(props.list) &&
            props.list.length > 0 &&
            Object.keys({ ...select, ...props.list[0] }).map(listValue => {
              let hide = ["S.No.", "Select", "checkbox0"]
              return (
                <td className="report-header text-center border">{listValue !== "checkbox0" && listValue} {!hide.includes(listValue) && <b onClick={() => props.sorting(listValue)} style={{ "font-size": "14px" }}>&#8645;</b>}{listValue === "Select" && <Field
                  isFormGroup={true}
                  inputType="checkbox"
                  inputName={"all"}
                  value={props.all}
                  onChange={props.handleCheckBox}
                  className="mx-auto d-flex w-100 justify-content-center"
                />}</td>
              );
            })}
        </tr>
        {props.list !== undefined &&
          Array.isArray(props.list) &&
          props.list.length > 0 &&
          props.list.map((listValue, index) => {
            return (
              <Fragment>
                <tr>
                  {props.type === "bulkUpdateProcess" && <td>
                    <Field
                      isFormGroup={false}
                      inputType="checkbox"
                      inputName={`checkbox` + index}
                      value={listValue[`checkbox${index}`]}
                      index={index}
                      onChange={props.handleCheckBox}
                    /></td>}{
                    props.type !== "bulkUpdateProcess" && <td>{index + 1}</td>
                  }
                  {Object.keys(listValue).map(listData => {
                    return listData === "SR NO" ? (
                      <td className="d-flex align-items-center justify-content-between">
                        {listValue[listData].number}
                        <img
                          title={`Go To Sample Page Of ${listValue[listData]._id}`}
                          className={"cursor-hover"}
                          style={{
                            cursor: "pointer",
                            marginTop: "-1px",
                            verticalAlign: "top",
                            marginLeft: "5px"
                          }}
                          onClick={() => samplePage(listValue[listData])}
                          src={externalLink}
                        />
                      </td>
                    ) : listData === "STYLE NO" && (
                      <td>
                        {listValue[listData].code}
                        <img
                          title={`Go To Style Page Of ${listValue[listData].code}`}
                          className={"cursor-hover"}
                          style={{
                            cursor: "pointer",
                            marginTop: "-1px",
                            verticalAlign: "top",
                            marginLeft: "5px"
                          }}
                          onClick={() => stylePage(listValue[listData])}
                          src={externalLink}
                        />
                      </td>
                    ) || (
                      <td style={{ textAlign: listData === "STYLE NAME" || listData === "SAMPLE TYPE" || listData === "CUST-DEPT" ? 'left' : 'center' }}>{listValue[listData]}</td>
                    );
                  })}
                </tr>

              </Fragment>
            );
          })}
        {/* {props.list !== undefined &&
        Array.isArray(props.list) &&
        props.list.length > 0 &&
        props.list.map(listValue => {
          return (
           
          );
        })} */}
      </tbody>
    </Fragment >
  );
};

export default ProcessUpdatesList;


// WEBPACK FOOTER //
// ./src/components/Report/reports/processUpdates.js